App.addModule(function(app) {

    app.on('loaded', () => {
		    
	    var onSubmitHandler = function(event) {
        	
        	var form = $(event.target);
        	
        	var dataType		= form.data('dataType') || 'json',
        		url				= form.data('ajaxUrl') || form.attr('action'),
        		useAjax			= form.data('useAjax') || form.data('use-ajax');
        	
        	if ($.type(useAjax) === 'function') {
        		useAjax = useAjax();
        	}
        	    	
        	form.trigger('submitBefore.mia.form')
        	app.dispatchEvent('form:submit', form[0])

            if (form[0].validated && !form[0].valid) {
                return false
            }

        	var button = form.find('button[type="submit"]');
        	
        	button.button('loading');
        	
		    if (useAjax) {
			    
			    event.preventDefault();
			    
			    form.children('.alert').remove();
			    
			    $.post({
				    url: url,
				    data: form.serializeArray(),
				    dataType: dataType
			    })
			    .done(function(result) {
				    
				    if (result.error) {
					    form.trigger('submitted.mia.form', [false, result.error]);
                        app.dispatchEvent('form:submitted', [form[0], false, result.error])
					    form.prepend(app.createAlertElement(result.error, 'danger'));
				    }
				    else  {
					    
					    form.trigger('submitted.mia.form', [true, result]);
                        app.dispatchEvent('form:submitted', [form[0], true, result])
					    
					    if (result.redirect_url) {
	            			window.location.href = result.redirect_url;
	            		}
	            		else if (result.success) {
	            			form.replaceWith(app.createAlertElement(result.success, 'success'));
	            		}
				    }
			    })
			    .fail(function(response) {
				    form.trigger('submitted.mia.form', [false, '']);
                    app.dispatchEvent('form:submitted', [form[0], false, ''])
			    })
			    .always(function() {
				    button.button('reset');
			    });
		    }
        }
	    
	    $('form').on('submit', onSubmitHandler);
    })
})
